/**
 * Created by rathompson on 11/11/21
 * File: Tab
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import type { EventHandler, VFC } from 'react'

/**
 *   Sidebar tab item
 */
const Tab: VFC<{
  selected?: boolean,
  active?: boolean,
  children: any,
  onClick: EventHandler<any>
}> = ({ selected, active, children, onClick }) => {
  const classNames = ['sidebar-tab']
  if (selected) {
    classNames.push('sidebar-tab-active tw-bg-white dark:tw-bg-gray-1050')
  }
  if (active) {
    classNames.push('tw-cursor-pointer')
  }
  return (
    <div className={classNames.join(' ').trim()} {...{ onClick }}>
      {children}
    </div>
  )
}

Tab.propTypes = {}
export default Tab
